var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoubleLineA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11035 23C7.59035 23 8.02035 22.7 8.17035 22.25L9.18035 19.42H14.8304L15.8204 22.24C15.9804 22.7 16.4104 23 16.8904 23C17.6804 23 18.2204 22.21 17.9404 21.48L13.6904 10.17C13.4304 9.47 12.7504 9 12.0004 9C11.2504 9 10.5704 9.47 10.3104 10.17L6.06035 21.48C5.78035 22.21 6.33035 23 7.11035 23ZM11.9404 11.6H12.0604L14.0904 17.39H9.91035L11.9404 11.6Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C5.45 8 5 7.55 5 7C5 6.45 5.45 6 6 6H18C18.55 6 19 6.45 19 7C19 7.55 18.55 8 18 8H6Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0001 4C5.0001 4.55 5.4501 5 6.0001 5H18.0001C18.5501 5 19.0001 4.55 19.0001 4C19.0001 3.45 18.5501 3 18.0001 3H6.0001C5.4501 3 5.0001 3.45 5.0001 4Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoubleLineA);
export default __webpack_public_path__ + "static/media/icon_double_line_a.50057a9c88be6a468336d5e12effa5ee.svg";
export { ForwardRef as ReactComponent };